var map = {
	"./BackButton.svg": 70654,
	"./Google-g-Logo.svg": 54527,
	"./Logo_text_white.svg": 19135,
	"./american_express.svg": 42974,
	"./balloon_animals.svg": 50830,
	"./characters.svg": 10706,
	"./clouds.svg": 68057,
	"./copy.svg": 44924,
	"./dictation_image.svg": 31161,
	"./discover.svg": 18769,
	"./dogs/border_collie.svg": 40935,
	"./dogs/chihuahua.svg": 63254,
	"./dogs/dog-background.svg": 54374,
	"./dogs/duo.svg": 55737,
	"./dogs/golden_retriever.svg": 93220,
	"./dogs/great_dane.svg": 18649,
	"./dogs/group.svg": 86787,
	"./dogs/solo.svg": 95751,
	"./dogs/st_bernard.svg": 59775,
	"./fast-forward-5.svg": 94050,
	"./inbox-main-alt.svg": 49316,
	"./inbox.svg": 13979,
	"./logo_icon.svg": 4426,
	"./mail_alert.svg": 2358,
	"./mail_plus.svg": 2579,
	"./man_with_hands.svg": 40162,
	"./master.svg": 76640,
	"./notebook_blue.svg": 69084,
	"./notebook_icon_rare2.svg": 60839,
	"./notebook_icon_white.svg": 17139,
	"./notebook_white.svg": 40941,
	"./rewind-5.svg": 36026,
	"./setup_wizard.svg": 49978,
	"./talkatoo_emblem.svg": 13622,
	"./talkatoo_logo.svg": 21384,
	"./talkatoo_logo_icon.svg": 9339,
	"./tooltip.svg": 39435,
	"./transcription_bubble.svg": 73877,
	"./undo.svg": 34808,
	"./upgrade/bird10.svg": 18771,
	"./upgrade/bird11.svg": 15349,
	"./upgrade/bird12.svg": 9648,
	"./upgrade/bird13.svg": 73565,
	"./upgrade/bird14.svg": 31013,
	"./upgrade/bird15.svg": 87464,
	"./upgrade/bird2.svg": 12885,
	"./upgrade/bird3.svg": 8915,
	"./upgrade/bird4.svg": 13211,
	"./upgrade/bird5.svg": 31557,
	"./upgrade/bird6.svg": 15361,
	"./upgrade/bird7.svg": 88010,
	"./upgrade/bird8.svg": 61567,
	"./upgrade/bird9.svg": 70577,
	"./upgrade/birds_on_a_wire1.svg": 51443,
	"./upgrade/birds_on_a_wire15.svg": 70042,
	"./upgrade/parler.svg": 57103,
	"./upgrade/sun.svg": 98802,
	"./upgrade/support.svg": 51593,
	"./visa.svg": 17676,
	"./voice_assistant_1.svg": 94775,
	"./workman.svg": 4535
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 29866;